import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@root/shared/service/translate.service";
import { NzModalService } from "ng-zorro-antd/modal";
import { Observable } from "rxjs";

@Component({
  selector: "host-share-link",
  templateUrl: "./share-link.component.html",
  styleUrls: ["./share-link.component.scss"],
})
export class ShareLinkComponent implements OnInit {
  listOfLink = [];
  page = 1;
  pageSize = 20;
  total = 0;
  constructor(
    private http: HttpClient,
    private modal: NzModalService,
    private t: TranslateService,
  ) {}

  ngOnInit() {
    this.fetchLinks();
  }

  private fetchLinks() {
    const params = {
      page: this.page,
      page_size: this.pageSize,
    };
    this.http.get("/api/calendar_share/list", { params }).subscribe((rst: any) => {
      this.listOfLink = rst?.data?.list;
      this.total = rst?.data?.count;
    });
  }

  private requestDeleteLink(id) {
    const params = { id };
    this.http.post("/api/calendar_share/delete", params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.fetchLinks();
      }
    });
  }

  onPageChange(page) {
    this.fetchLinks();
  }

  onDelete(id) {
    this.displayDeleteWarning().subscribe(() => {
      this.requestDeleteLink(id);
    });
  }

  private displayDeleteWarning() {
    return new Observable((observer) => {
      const modal = this.modal.confirm({
        nzTitle: this.t.t("status-calendar_html_shared_link_delete_title"),
        nzContent: this.t.t("status-calendar_html_shared_link_delete_content"),
        nzOkText: this.t.t("word.yes"),
        nzWidth: 600,
        nzOnOk: () => {
          observer.next(true);
        },
      });

      modal.afterClose.subscribe(() => {
        observer.complete();
      });
    });
  }
}
